<template>
    <v-card width="100%" flat>
        <v-card-title>
            <div class="headline">
                Vstupenky
            </div>
            <v-spacer></v-spacer>

            <v-combobox
                    clearable
                    single-line
                    hide-details
                    class="pt-0"
                    label="Filtrovat podle události"
                    :items="events"
                    item-value="id"
                    item-text="name"
                    v-model="selectedEvent"
            ></v-combobox>

            <v-spacer></v-spacer>

            <v-combobox
                    clearable
                    single-line
                    hide-details
                    class="pt-0"
                    label="Filtrovat podle sady"
                    :items="ticketsets"
                    :disabled="!selectedEvent"
                    item-value="id"
                    item-text="name"
                    v-model="selectedTicketset"
            ></v-combobox>

            <v-spacer></v-spacer>

            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Vyhledávání"
                    single-line
                    class="pt-0"
                    hide-details
                    clearable
            ></v-text-field>

            <v-spacer style="width: 20px"></v-spacer>

            <!--    <v-btn fab dark small color="success" @click="addItem">-->
            <!--        <v-icon dark>add</v-icon>-->
            <!--    </v-btn>-->

            <v-spacer style="width: 20px"></v-spacer>

            <v-btn :href="exportUrl"
                   download="tickets-export.csv"
                   class="mr-5 mb-2"
            >
                Export CSV
            </v-btn>

            <v-btn @click="openImportDialog"
                   class="mr-0 mb-2"
            >
                Import CSV
            </v-btn>
        </v-card-title>

        <v-data-table
                v-model="selected"
                :headers="headers"
                :items="serverTickets"
                :server-items-length="$store.state.ticket.paging.totalCount"
                :loading="$store.state.ticket.loading"
                :options.sync="options"
                show-select dense
                :items-per-page.sync="pageSize"
                :footer-props="{
                    'items-per-page-options': [10, 20, 50, 100, 500, 1000]
                }"
        >
            <template v-slot:progress="props">
                <v-progress-linear color="blue" height="5" indeterminate></v-progress-linear>
            </template>

            <template v-slot:body.prepend="props">
                <tr v-if="!$store.state.ticket.loading">
                    <td :colspan="props.headers.length" style="padding: 0; height: 2px">
                    </td>
                </tr>
            </template>

            <template v-slot:item.used="{ item }">
                <v-icon v-if="item.used" small color="green">check_circle</v-icon>
                <v-icon v-if="!item.used" small color="red">remove_circle</v-icon>
            </template>

            <template v-slot:item.usedAt="{ item }">
                <template v-if="item.usedAt">
                    {{ item.usedAt | moment("D. M. YYYY HH:mm:ss") }}
                </template>
                <template v-else>---</template>
            </template>
            <template v-slot:item.ticketset="{ item }">
                {{ item.price?.ticketset?.name }}
            </template>
            <template v-slot:item.price="{ item }">
                {{ item.price?.name }}
            </template>

            <template v-slot:item.action="{ item }">
                <EditDeleteActions
                        @delete="deleteItem(item)"
                        @edit="editItem(item)"
                />
            </template>

            <template v-slot:footer="{ item }">
                <div class="footer-block"><div class="in">
                    <v-btn small color="danger" :disabled="!selected.length"
                           @click="deleteSelected"
                    >
                        <v-icon left color="red">delete_forever</v-icon>
                        Smazat vybrané vstupenky ({{ selected.length }})
                    </v-btn>
                </div></div>
            </template>
        </v-data-table>

        <TicketImportDialog ref="importDialog" @complete="loadTickets(true)" />

        <TicketDialog ref="dialog" @complete="onComplete" />

        <DeleteConfirm :show="deleteConfirm"
                       @confirm="doDeleteConfirm"
                       @cancel="deleteConfirm=false" />

        <DeleteConfirm :show="deleteSelectedConfirm"
                       @confirm="doDeleteSelectedConfirm"
                       @cancel="deleteSelectedConfirm=false"
                       message="Opravdu chcete smazat všechny vybrané záznamy?"
        />
    </v-card>
</template>

<script>
    import TicketImportDialog from '../components/dialogs/TicketImportDialog'
    import EditDeleteActions from '../components/EditDeleteActions'
    import BaseListMixin from '../mixins/BaseListMixin'
    import DeleteConfirm from '../components/DeleteConfirm'
    import TicketDialog from '../components/dialogs/TicketDialog'

    export default {
        mixins: [BaseListMixin],

        components: {
            TicketImportDialog, EditDeleteActions, DeleteConfirm, TicketDialog
        },

        data () {
            return {
                selected: [],
                module: 'ticket',
                headers: [
                    { text: 'Kód', value: 'code', width:'150px' },
                    { text: 'Použitá', value: 'used', align:'center', width: '100px' },
                    { text: 'Dne', value: 'usedAt', width: '200px' },
                    { text: 'Sada vstupenek', value: 'ticketset', width:'200px' },
                    { text: 'Cenová hladina', value: 'price', width:'200px' },
                    { text: 'Jméno', value: 'firstName', width:'50%' },
                    { text: 'Příjmení', value: 'lastName', width:'50%' },
                    { text: '', value: 'action', width: '1px' }
                ],
                search: '',
                selectedEvent: null,
                selectedTicketset: null,
                options: {},
                pageSize: 10,
                loadTicketsTimer: null,
                deleteSelectedConfirm: false
            }
        },

        watch: {
            options: {
                handler () {
                    this.loadTickets()
                },
                deep: true
            },
            selectedEvent() {
                this.loadTickets(true)
            },
            selectedTicketset() {
                this.loadTickets(true)
            },
            search() {
                this.loadTickets(true)
            },
            pageSize () {
                this.loadTickets(true)
            }
        },

        computed: {
            events () {
                return this.$store.state.event.list
            },
            ticketsets () {
                if (this.selectedEvent) {
                    return this.$store.state.ticketset.list.filter(
                        ticketset => ticketset.event.id === this.selectedEvent.id
                    )
                } else {
                    return []
                }
            },
            serverTickets () {
                return this.$store.state.ticket.list
            },
            exportUrl() {
                let params = {
                    order_by: (this.options.sortDesc ? '-':'') + this.options.sortBy,
                }
                if (this.selectedEvent) {
                    params['event'] = this.selectedEvent.id
                }
                if (this.selectedTicketset) {
                    params['ticketset'] = this.selectedTicketset.id
                }
                if (this.search !== '') {
                    params['search'] = this.search
                }

                return '/ticket-export/?' + new URLSearchParams(params).toString()
            }
        },

        created() {
            this.$store.dispatch('event/list')
            this.$store.dispatch('ticketset/list')
        },

        methods: {
            loadTickets (reset) {
                clearTimeout(this.loadTicketsTimer)
                this.loadTicketsTimer = setTimeout( () => {
                    this.loadTicketsPost(reset)
                }, 10)
            },
            loadTicketsPost (reset) {
                if (reset) {
                    this.options.page = 1
                }

                let params = {
                    page: this.options.page,
                    orderBy: (this.options.sortDesc ? '-':'') + this.options.sortBy,
                }

                if (this.selectedEvent) {
                    params['event'] = this.selectedEvent.id
                }
                if (this.selectedTicketset) {
                    params['ticketset'] = this.selectedTicketset.id
                }
                if (this.search !== '') {
                    params['search'] = this.search
                }

                if (this.options.page === 1) {
                    this.$store.dispatch('ticket/list', {
                        ...params,
                        first: this.pageSize,
                    })
                } else if (this.options.page > this.$store.state.ticket.paging.page) {
                    this.$store.dispatch('ticket/list', {
                        ...params,
                        first: this.pageSize,
                        after:this.$store.state.ticket.paging.endCursor
                    })
                } else {
                    this.$store.dispatch('ticket/list', {
                        ...params,
                        last: this.pageSize,
                        before:this.$store.state.ticket.paging.startCursor
                    })
                }
            },

            ticketsetById (id) {
                let ret = {}
                this.events.forEach(event => {
                    let ticketset = event.ticketsets.find(ticketset => ticketset.id === id)
                    if (ticketset) {
                        ret = ticketset
                    }
                })
                return ret
            },

            deleteItem (obj) {
                this.deleteConfirmId = parseInt(atob(obj.id).split(':')[1])
                this.deleteConfirm = true
            },

            async doDeleteConfirm () {
                this.deleteConfirm = false
                const res = await this.$store.dispatch(`${this.module}/delete`, this.deleteConfirmId)
                if (res && res.ok) {
                    this.loadTickets(true)
                    this.$refs.dialog.hide()
                }
            },

            deleteSelected () {
                this.deleteSelectedConfirm = true
            },

            async doDeleteSelectedConfirm () {
                this.deleteSelectedConfirm = false
                const sel = this.selected.map( item => parseInt(atob(item.id).split(':')[1]) )
                const res = await this.$store.dispatch(`${this.module}/deleteMulti`, sel)
                if (res && res.ok) {
                    this.loadTickets(true)
                    this.$refs.dialog.hide()
                    this.selected = []
                }
            },

            openImportDialog () {
                this.$refs.importDialog.show()
            },

            async onComplete (form) {
                let res
                if (this.$refs.dialog.type === 'add') {
                    res = await this.$store.dispatch(`${this.module}/create`, form)
                } else {
                    res = await this.$store.dispatch(`${this.module}/update`, form)
                }
                if (res && res.ok) {
                    this.loadTickets(true)
                    this.$refs.dialog.hide()
                }
            },
        }
    }
</script>

<style lang="scss">
    .footer-block {
        position: absolute;
        .in {
            position: absolute;
            top: 10px;
        }
    }
</style>
